import { render, staticRenderFns } from "./InjectStudy.vue?vue&type=template&id=42ccb78a&"
import script from "./InjectStudy.vue?vue&type=script&lang=js&"
export * from "./InjectStudy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports